import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios';
import { userObj } from "../../../../helper/protectedRoutes";
import baseUrl from '../../../../helper/api';
import axios from "../../../../api/axios";

const initialState = {
    wallet:{},
    isFetching:null,
    status:null,
}

const token = userObj?.token

export const getWallet = createAsyncThunk(
    'partner/getWallet',
    async (id, {rejectWithValue}) => {
        
        try{
            const response = await axios.get("/Wallets/Get",
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response?.data
        } catch (err) {
            console.log(err.response)
            return rejectWithValue(err.response.data.title)
        }
        
    }
)


const getWalletSlice = createSlice({
    name: 'getWallet',
    initialState,
    reducers: {},
    extraReducers:{
        [getWallet.pending]: (state, action) => {
            state.status='pending';
            state.isFetching=true;
        },
        [getWallet.fulfilled]: (state, action) => {
            state.status='success';
            state.isFetching=false;
            state.wallet = action.payload;
            console.log('wallet >>', state.wallet)
            // localStorage.setItem('user', JSON.stringify(action.payload))
        },
    
        [getWallet.rejected]: (state, action) => {
            state.status='failed';
            state.isFetching=false;
        }
    }
})

export default getWalletSlice.reducer;